module.exports = __webpack_public_path__ + "static/media/css.b1d1fae6.svg";